// extracted by mini-css-extract-plugin
export default {"translateButton":"TranslateButton_translateButton__X+6RO","isLoading":"TranslateButton_isLoading__dF64y"};